import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import WaiterStepperItem from '../../components/WaiterStepperItem'
import injectSheet from 'react-jss'
import styles from '../../assets/styles/components/WaiterStepperItem'
import { bindActionCreators } from 'redux'
import * as basketActions from '../../actions/components/basket'
import * as stepperActions from '../../actions/components/stepper'
import * as optionGroupsActions from '../../actions/components/optionGroups'
import * as categoryDetailListActions from '../../actions/components/categorydetaillist'

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
  }
}

const mapDispatchToProps = (dispatch) => {
  const {
    addToOrder,
    setStash,
    resetStash,
  } = bindActionCreators(basketActions, dispatch)

  const {
    switchBottomSheet,
    activeBottomSheetSubmitButton,
  } = bindActionCreators(stepperActions, dispatch)

  const {
    resetStashByOptionGroups,
    resetStashByRadioGroups,
  } = bindActionCreators(optionGroupsActions, dispatch)

  const {
    updateSearchModeDisplay,
  } = bindActionCreators(categoryDetailListActions, dispatch)

  return {
    addToOrder,
    setStash,
    resetStash,
    switchBottomSheet,
    resetStashByOptionGroups,
    resetStashByRadioGroups,
    activeBottomSheetSubmitButton,
    updateSearchModeDisplay,
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(injectSheet(styles)(WaiterStepperItem))))



// WEBPACK FOOTER //
// ./src/containers/components/WaiterStepperItem.js